/* Vendor */

/* Fonts */
import './fonts/main.css';

/* Styles */
import './scss/main.scss';

/* Scripts */
import './js/main';


//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 73
// module chunks = 0